export default __webpack_public_path__ + "static/13-670e9ee0ef3e1dda3243769173037d25.jpg";